export const PORTAL_MODAL_NAMES = {
  PUBLISH_PAGE: 'publishPageModal',
  PUBLISH_CONTENT: 'publishContentModal',
  DELETE_TABLE_POPUP: 'deletePopupModal',
  DELETE_BADGE: 'deleteBadgeModal',
  INCOMPLETE_TRANSLATIONS: 'incompleteTranslationsModal',
  DELETE_PRODUCT_POPUP: 'deleteProductModal',
  DELETE_OFFER_UI_POPUP: 'deleteOfferUIModal',
  DELETE_ROLLING_OFFER_POPUP: 'deleteRollingOfferModal'
} as const;

export const modalConfigs: Record<
  string,
  { title: string; description: string }
> = {
  [PORTAL_MODAL_NAMES.PUBLISH_PAGE]: {
    title: 'Publish Page',
    description:
      'Are you sure want to publish this page? Saving these changes will make the page public.'
  },
  [PORTAL_MODAL_NAMES.PUBLISH_CONTENT]: {
    title: 'Publish Content',
    description: 'This will make the content accessible to everyone'
  },
  [PORTAL_MODAL_NAMES.DELETE_TABLE_POPUP]: {
    title: 'Delete Popup',
    description: 'Are you sure want to delete this popup?'
  },
  [PORTAL_MODAL_NAMES.DELETE_BADGE]: {
    title: 'Delete Badge',
    description: 'Are you sure want to delete this badge?'
  },
  [PORTAL_MODAL_NAMES.DELETE_PRODUCT_POPUP]: {
    title: 'Delete Product',
    description: 'Are you sure want to delete this product?'
  },
  [PORTAL_MODAL_NAMES.DELETE_OFFER_UI_POPUP]: {
    title: 'Delete Offer Design',
    description: 'Are you sure want to delete this offer design?'
  },
  [PORTAL_MODAL_NAMES.DELETE_ROLLING_OFFER_POPUP]: {
    title: 'Delete Rolling Offer',
    description: 'Are you sure want to delete this rolling offer?'
  },
  [PORTAL_MODAL_NAMES.INCOMPLETE_TRANSLATIONS]: {
    title: 'Incomplete Translations Detected',
    description: 'Some languages are incomplete. Do you want to save anyway?'
  }
};
